// pages/CallsExplorer.tsx

import { CallsExplorerProvider } from "../components/callsExplorer/callsExplorerContext";
import { CallsExplorerPage } from "../components/callsExplorer/callsExplorerPage";

const CallsExplorer: React.FC = () => (
  <CallsExplorerProvider>
    <CallsExplorerPage />
  </CallsExplorerProvider>
);

export default CallsExplorer;
